module.exports = __webpack_public_path__ + "img/combo-sdk.d9a1277.png";